import { render, staticRenderFns } from "./archived-modal.vue?vue&type=template&id=8ff37ee2&scoped=true&"
import script from "./archived-modal.vue?vue&type=script&lang=js&"
export * from "./archived-modal.vue?vue&type=script&lang=js&"
import style0 from "./archived-modal.vue?vue&type=style&index=0&id=8ff37ee2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff37ee2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
